module.exports = __webpack_public_path__ + "img/herring.a44a10e1.png";